<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Hallazgos más frecuentes reportados por los supervisores" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-data-table
                    :fields="headers"
                    :items="tableData"
                >
                    <template slot="percentaje" slot-scope="data">
                        {{ data.item.percentaje | decimal(2) }} %
                    </template>
                    <template slot="acum" slot-scope="data">
                        {{ data.item.acum | decimal(2) }} %
                    </template>
                </app-data-table>
            </b-col>
            <b-col cols="12">

            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import supervisionChecklistRepository from '../../../../repositories/supervisionChecklist.repository';
export default {
    name: 'supervision_indicators',
    data: () => ({
        rawData: [],
        headers: [
            {
                label: 'Item',
                key: 'name'
            },
            {
                label: 'Cantidad',
                key: 'cant'
            },
            {
                label: 'Porcentaje',
                key: 'percentaje'
            },
            {
                label: 'Acumulado',
                key: 'acum'
            },
        ],
    }),
    computed: {
        tableData() {
            return this.rawData.map(item => ({...item, classes: item.acum <= 80? 'item-important text-danger':'item-trivial'}))
        }
    },
    methods: {
        async loadSupervisionIndicatorsInfo() {
            const sr = {...supervisionChecklistRepository};
            this.rawData = await sr.getSupervisionChecklistIndicators();
        }
    },
    created() {
        this.loadSupervisionIndicatorsInfo();
    }
}
</script>